import styled from 'styled-components'

const Content = styled.div`
  background-color: white;
  -webkit-box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.25);
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.25);
  margin-top: 1rem;
  padding: 3rem;
  height: 100%;
`

export default Content
